import { ImporterOfRecordDetails, ImporterOfRecord } from './ImporterOfRecordDetails';
import { Text } from '@nike/eds';
import getImportersOfRecordMock from "../../mocks/getImportersOfRecord.mock.json";

function getImportersOfRecordFromMock() {
  // Safely extract items array from the mock structure
  return getImportersOfRecordMock.data?.getImportersOfRecord?.items || [];
}

const useImportersApi = () => {
  return { data: { items: getImportersOfRecordFromMock() }, isLoading: false };
};

export function ImportersOfRecord() {
  const { data, isLoading } = useImportersApi();

  return (
    <div className="eds-spacing--mb-24">
      <Text
        className="eds-spacing--mb-8"
        font={'title-3'}
        as={'h2'}
      >
        Importers of Record
      </Text>
      {isLoading && <Text>Loading importers of record...</Text>}
      <div className="eds-flex eds-gap--16 ">
        {(data?.items || []).map(
            (importer: ImporterOfRecord, index: number) => (
              <ImporterOfRecordDetails key={index} importer={importer} />
            )
          )}
      </div>
    </div>
  );
}